import type { SxProps } from '@mui/material';
import type { CSSProperties } from 'react';

const sxStyles: Record<string, SxProps> = {
  mainContainer: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    p: 2,
  },
  card: {
    maxWidth: 400,
    width: '100%',
    borderRadius: 4,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
  },
  welcomeText: {
    fontWeight: 'bold',
    textAlign: 'center',
    mb: 2,
  },
  link: {
    fontWeight: 'bold',
    color: 'primary.main',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  divider: {
    my: 3,
  },
  ssoText: {
    textAlign: 'center',
    mb: 2,
    fontWeight: 'bold',
  },
  googleButton: {
    textTransform: 'none',
  },
};

const cssStyles: Record<string, CSSProperties> = {
  logoStyle: {
    width: '100px',
    marginBottom: '16px',
  },
};

export { sxStyles, cssStyles };
